import { createFileRoute } from '@tanstack/react-router';
import { AddOnsIndex } from '@/pages/billing/AddOnsIndex';

export const Route = createFileRoute('/_authenticated/_app/settings/billing/addons')({
	component: AddOnsIndex,
});
